import { UseFormReturn } from "react-hook-form";
import { useState } from "react";
import { Step } from "./constants";
import { CaretLeft } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { DrawerHeader } from "@/components/ui/drawer";
import { useTranslation } from "react-i18next";
import { InvoiceFormValues } from "./index";
import { Input } from "@/components/ui/input";

const InvoiceNumberStep = ({
  form,
  setStep,
}: {
  form: UseFormReturn<InvoiceFormValues>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation();
  const [invoiceNumber, setInvoiceNumber] = useState(
    form.getValues("invoiceNumber")
  );

  return (
    <div>
      <DrawerHeader
        title={t("label.add_invoice_number")}
        leftButton={
          <button type="button" onClick={() => setStep(Step.INITAL)}>
            <CaretLeft color="#E3EDFC" size={18} />
          </button>
        }
        rightButton={<span className="w-[18px]" />}
      />

      <Input
        data-testid="invoice-form-invoice-number-input"
        className=""
        placeholder={t("label.enter_invoice_number")}
        value={invoiceNumber}
        onChange={(e) => setInvoiceNumber(e.target.value)}
      />

      <Button
        data-testid="invoice-form-invoice-number-submit-button"
        className="mt-4 w-full"
        onClick={() => {
          form.setValue("invoiceNumber", invoiceNumber);
          setStep(Step.INITAL);
        }}
      >
        {t("button.add")}
      </Button>
    </div>
  );
};

export default InvoiceNumberStep;
